import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',

  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',

    iK: '#df040b',

    semAz: '#4177A6',
    semAzc: '#59A8D9',
    semVr: '#41A66C',
    semRj: '#D94E5A',
    semBl: '#F2F2F2',
    semAm: '#F2C53D',

    sem1: '#497CBF',
    sem3: '#6eb683',
    sem4: '#e75f49',
    sem5: '#ededed',
    sem6: '#b3b2b2',
    sem7: '#f9b233',

    Iniciación:'#FF5252',
    Desarrollo:'#E86205',
    Intermedio:'#FFC107',
    Maduración:'#D4E805',
    Robusto:'#4CAF50'
  }
})
